import { useState, useEffect } from 'react';
import './LogViewer.css';

// Este componente captura e exibe logs do console na tela
// Útil para debug quando o console do navegador não está visível

// Capturar logs do console
const logs = [];
const originalLog = console.log;
const originalError = console.error;
const originalWarn = console.warn;

console.log = (...args) => {
  logs.push({ type: 'log', message: args.join(' '), time: new Date().toLocaleTimeString() });
  if (logs.length > 100) logs.shift(); // Manter apenas os últimos 100 logs
  originalLog(...args);
};

console.error = (...args) => {
  logs.push({ type: 'error', message: args.join(' '), time: new Date().toLocaleTimeString() });
  if (logs.length > 100) logs.shift();
  originalError(...args);
};

console.warn = (...args) => {
  logs.push({ type: 'warn', message: args.join(' '), time: new Date().toLocaleTimeString() });
  if (logs.length > 100) logs.shift();
  originalWarn(...args);
};

export function LogViewer() {
  const [showLogs, setShowLogs] = useState(false);
  const [logEntries, setLogEntries] = useState([]);

  useEffect(() => {
    const interval = setInterval(() => {
      setLogEntries([...logs]);
    }, 500);

    return () => clearInterval(interval);
  }, []);

  if (!showLogs) {
    return (
      <button
        className="log-viewer-toggle"
        onClick={() => setShowLogs(true)}
        title="Mostrar logs"
      >
        📋
      </button>
    );
  }

  return (
    <div className="log-viewer">
      <div className="log-viewer-header">
        <h3>Logs do Console</h3>
        <button onClick={() => setShowLogs(false)}>✕</button>
        <button onClick={() => logs.length = 0}>Limpar</button>
      </div>
      <div className="log-viewer-content">
        {logEntries.length === 0 ? (
          <p>Nenhum log ainda...</p>
        ) : (
          logEntries.map((log, index) => (
            <div key={index} className={`log-entry log-${log.type}`}>
              <span className="log-time">{log.time}</span>
              <span className="log-message">{log.message}</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

